import { render, staticRenderFns } from "./GridHistory.vue?vue&type=template&id=3dd9053c&"
import script from "./GridHistory.vue?vue&type=script&lang=js&"
export * from "./GridHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports